<template>
  <div>
    <v-app-bar
      :color="$vuetify.theme.dark ? 'dark' : getThemeMode.appBarColor"
      :dark="false"
      app
      class="px-sm text-left "
      flat
      height="84"
    >
      <v-app-bar-nav-icon
        v-ripple="{ class: 'primary--text' }"
        @click="toggleVerticalSidebarDrawer"
      />
      <span class="page-title">{{ $route.meta.title }}</span>
      <v-progress-linear
        :active="getThemeMode.isLoading"
        :indeterminate="getThemeMode.isLoading"
        absolute
        bottom
        color="primary"
      />
      <v-spacer/>
      <a href="https://dashboard.meraki.com" target="_blank" class="meraki-logo">
        <img src="@/assets/images/logos/cisco-meraki-logo.webp"/>
      </a>
      <v-menu
        bottom
        min-width="200px"
        rounded
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-chip
            pill
            class="transparent rounded-pill py-6"
            v-on="on"
          >
            Welcome{{ userProfile.company && ' ' + userProfile.company }}!
            <v-btn
              icon
              large
              v-on="on"
              class="ml-2"
            >
              <v-avatar>
                <v-img src="@/assets/images/avatars/001-man.svg"></v-img>
              </v-avatar>
            </v-btn>
          </v-chip>
        </template>
        <v-card>
          <v-list-item-content class="justify-center">
            <div class="mx-auto pa-4 text-center">
              <v-avatar class="mt-4 mb-2">
                <v-img src="@/assets/images/avatars/001-man.svg"></v-img>
              </v-avatar>
              <h3>{{ userProfile.company }}</h3>
              <p class="text-caption pb-2">
                {{ userProfile.email }}
              </p>
              <v-divider class="my-3"></v-divider>
              <v-btn
                depressed
                rounded
                text
                @click="logoutUser"
              >
                <v-icon left>
                  mdi-logout
                </v-icon>
                Logout
              </v-btn>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>

    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { sendGet } from "@/util/api";

export default {
  name: "AppHeader",
  components: {},
  computed: {
    ...mapGetters(['getThemeMode', 'loggedInUser']),
  },
  data() {
    return {
      notificationDrawer: false,
      searchDrawer: false,
      navbarOptions: {
        elementId: "main-navbar",
        isUsingVueRouter: true,
        mobileBreakpoint: 992,
        brandImagePath: "./",
        brandImageAltText: "brand-image",
        collapseButtonOpenColor: "#661c23",
        collapseButtonCloseColor: "#661c23",
        showBrandImageInMobilePopup: true,
        ariaLabelMainNav: "Main Navigation",
        tooltipAnimationType: "shift-away",
        menuOptionsLeft: [],
      },
      userProfile: {
        company: this.$store.state?.loggedInUser?.username ?? '',
        email: this.$store.state?.loggedInUser?.username ?? '',
      }
    };
  },
  mounted() {
    this.loadProfile();
  },
  methods: {
    ...mapActions([
      "changeVerticalSidebarDrawer",
      "changeVerticalSidebarMini",
      "signOut",
      'setIdentity',
      'trackEvent',
      'clearSession',
    ]),
    toggleVerticalSidebarDrawer() {
      this.changeVerticalSidebarDrawer();

      // this.$emit("update:mini-variant");
      // console.log("check");
    },
    async logoutUser() {
      await this.signOut();
      this.trackEvent({
        eventName: 'UserLoggedOut',
        eventDetails: this.userProfile,
      });
      this.clearSession();
      // await this.$router.push("/login");
    },
    async loadProfile() {
      try {
        const response = await sendGet('user_profile')
        const { email, company } = response.results;
        this.userProfile = { email, company };
        this.setIdentity(this.userProfile);
      } catch (error) {
        console.log(error)
      }
    }
  },
  watch: {
    loggedInUser(val) {
      if (!val) {
        this.$router.push('/login')
      }
    },
  }
};
</script>

<style lang="scss">
.header-backup {
  display: block;
  width: 100%;
  height: 102px;
  position: fixed;
  top: 0;
  z-index: 5;
  background: linear-gradient(
      180deg,
      hsla(0, 0%, 97.3%, 0.95) 44%,
      hsla(0, 0%, 97.3%, 0.46) 73%,
      hsla(0, 0%, 100%, 0)
  ) !important;
  left: 0;

  &.theme--dark {
    background: linear-gradient(
        180deg,
        rgba(5, 5, 5, 0.95) 44%,
        rgba(0, 0, 0, 0.46) 3%,
        hsla(0, 0%, 100%, 0)
    ) !important;
  }
}

.tippy-box[data-theme~="light"] {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
  0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.vnb {
  background: transparent !important;

  &__menu-options {
    margin-top: 3px !important;

    &__option {
      &__link {
        &:focus {
          outline: none;
          border: 1px solid none;
        }

        &:hover {
          color: #0081ff;

          .vnb__menu-options__option__arrow {
            fill: #0081ff;
          }
        }

        &__icon {
          svg {
            fill: #0081ff !important;
          }
        }
      }
    }
  }

  &__sub-menu-options {
    &__option {
      &__link {
        &:focus {
          outline: none;
          border: 1px solid none;
        }

        color: #000 !important;

        &:hover {
          color: #0081ff !important;
        }
      }
    }
  }
}

.vnb__collapse-button {
  &:focus {
    border: 1px solid none;
    outline: none;
  }

  &:after {
    content: "\F035C";
    font-size: 25px;
    font-weight: 600;
    font-family: "Material Design Icons";
  }

  svg {
    display: none !important;
  }
}

.vnb__popup {
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: scroll !important;

  .vnb__popup__top__close-button {
    &:focus {
      border: 1px solid none;
      outline: none;
    }

    top: 20px;
    right: -33px;

    svg {
      fill: #000 !important;
    }
  }
}

.page-title {
  font-weight: 600;
  font-size: 28px;
  line-height: 35px;
  text-transform: uppercase;
  color: #1A1A1C;
}

.meraki-logo {
  display: none;

  @media (min-width: 768px) {
    display: block;
    width: 150px;
    margin-right: 20px;
  }

  @media (min-width: 992px) {
    width: 150px;
    margin-right: 50px;
  }

  @media (min-width: 1264px) {
    width: 150px;
    margin-right: 100px;
  }
}
</style>
